import { getRouteList } from '@/request';
import routeOptList from '@/router/routerList';
import router from '@/router';
import { localSet, localGet, sessionGet, sessionSet } from '@/utils';
import { useStore } from 'vuex';
const store = useStore()

function createRouteMap(routeList = [], map = new Map()) {
  routeList.forEach((route) => {
    const routeKey = route.node.route_key || route.node.resource_name;
    if (routeKey) {
      map.set(routeKey, route);
    }
    // 兼容仅有 resource_name、或 route_key 与展示名不一致的历史数据
    if (route.node.resource_name && route.node.resource_name !== routeKey) {
      map.set(route.node.resource_name, route);
    }
    if (route.childs) {
      createRouteMap(route.childs, map);
    }
  });
  return map;
}

export default {
  namespaced: true,
  state: {
    keepAliveList: [],
    menuTreeList: localGet('menuTreeData') || [],
    tabsList: sessionGet('tabList') || [],
    routeMap: new Map()
  },
  mutations: {
    /**
     *
     * @param {*} state
     * @param {*} routes string | []string
     * @param {*} type 'add' | 'delete' | 'replace' | 'clear'
     * @returns
     */
    updateKeepAlive(state, { routes, type }) {
      if (!['add', 'replace', 'delete', 'clear'].includes(type)) {
        console.error('updateKeepAlive: type is not defined', type);
        return;
      }
      routes = Array.isArray(routes) ? routes : [routes];
      const updateFn = {
        add() {
          state.keepAliveList = [...new Set(state.keepAliveList.concat(routes))];
        },
        replace() {
          state.keepAliveList = routes;
        },
        delete() {
          const routesMap = routes.reduce((prev, item) => {
            prev[item] = true;
            return prev;
          }, {});
          state.keepAliveList = state.keepAliveList.filter((routeName) => !routesMap[routeName]);
        },
        clear() {
          state.keepAliveList = [];
        }
      };
      updateFn[type]();
    },
    updateTabsList(state, { tab, type }) {
      if (!['add', 'replace', 'delete', 'clear'].includes(type)) {
        console.error('updateTabsList: type is not defined', type);
        return;
      }
      let tabs = Array.isArray(tab) ? tab : [tab];

      const updateFn = {
        add() {
          // tabsList 已存在 去重
          // tabs = tabs.filter((currebtTab) =>
          //   state.tabsList.every((tabItem) => tabItem.name !== currebtTab.name)
          // );

          // 遍历tabs 过滤重复的路由
          tabs = tabs.reduce((prev, item) => {
            if (!item) return prev;
            // 找到相同的 index
            const sameTabIndex = state.tabsList.findIndex((tabItem) => tabItem.name === item.name);

            if (sameTabIndex > -1) {
              // 如果存在相同tab对象 直接替换
              //  替换的目的是防止参数不同，路由相同的情况
              //  如 { name: 'List', query: {id: 1} }
              //  替换成 { name: 'List', query: {id: 2} }
              //  这种情况下 需要替换 防止参数缓存
              state.tabsList.splice(sameTabIndex, 1, {
                ...item,
                label: state.tabsList[sameTabIndex].label
              });
            } else {
              prev.push(item);
            }
            return prev;
          }, []);
          const routeList = router.getRoutes();
          // 格式化
          // tabs = tabs.map((currebtTab) => ({
          //   ...currebtTab,
          //   label: routeList.find((route) => route.name === currebtTab)?.meta?.title
          // }));

          tabs = tabs.reduce((prev, currebtTab) => {
            const currentRoute = routeList.find((route) => route.name === currebtTab.name);
            if (currentRoute?.meta?.inTab) {
              prev.push({
                ...tab,
                label: currentRoute.meta.title
              });
            }
            return prev;
          }, []);
          state.tabsList = state.tabsList.concat(tabs);
        },
        replace() {
          const routeList = router.getRoutes();
          tabs = tabs.reduce((prev, currebtTab) => {
            const currentRoute = routeList.find((route) => route.name === currebtTab.name);

            if (currentRoute?.meta?.inTab) {
              prev.push({
                ...tab,
                label: currentRoute.meta.title
              });
            }
            return prev;
          }, []);
          state.tabsList = tabs;
        },
        delete() {
          const tabsMap = tabs.reduce((prev, currebtTab) => {
            prev[currebtTab.name] = true;
            return prev;
          }, {});
          state.tabsList = state.tabsList.filter((currentTab) => !tabsMap[currentTab.name]);
        },
        clear() {
          state.tabsList = [];
        }
      };
      updateFn[type]();
      sessionSet('tabList', state.tabsList);
    },
    setMenuList(state, data) {
      localSet('menuTreeData', data);
      state.menuTreeList = data;
    },
    setRouteMap(state, routeMap) {
      state.routeMap = routeMap;
    }
  },
  actions: {
    getRouteList({ commit }) {
      getRouteList().then((data) => {
        // console.log('routeOptList', routeOptList);
        if (data) {
          const routerList = data.roots;
          const routeMap = createRouteMap(routerList);
          commit('setRouteMap', routeMap);
          let firstRouteName;
          routeOptList.forEach((route) => {
            if (route.meta && route.meta.isDynamic) {
              if (route.meta.id && routeMap.get(route.meta.id)) {
                // 如果是需要动态加载的路由
                const currentRoute = routeMap.get(route.meta.id);
                // 将本地配置项name同步到 routerList 可用于侧边栏跳转

                currentRoute.node.name = route.name;
                // 将后台获取到的 title 同步到本地路由配置 用于页面标签显示
                route.meta.title = currentRoute.node.resource_name;
                if (!firstRouteName) firstRouteName = currentRoute.node.name;
                router.addRoute('ManagePage', route);
              }

              return;
            }
            // 不是动态路由直接添加
            router.addRoute('ManagePage', route);
          });
          commit('setMenuList', routerList);
          // if (router.currentRoute.value.name === 'ManagePage') {
          //   router.replace({ name: 'AccountManage' });
          // }
          if (localStorage.getItem('userType') == 1) {
            router.replace({ name: 'AnalysisApp'})
          }
        } else if (data === '') {
          // router.push({ name: 'ManagePage' });
          commit('setMenuList', []);
          commit('setRouteMap', new Map());
        }
      });
    },
    addRoutes({ state, commit }, payload) {
      let data = payload || state.menuTreeList;
      // 创建一个路由map { id: {title, name} }
      const routeMap = createRouteMap(data);

      commit('setRouteMap', routeMap);
      routeOptList.forEach((route) => {
        if (route.meta && route.meta.isDynamic && route.meta.id) {
          if (routeMap.get(route.meta.id)) {
            const currentRoute = routeMap.get(route.meta.id);
            // 将本地配置项name同步到 routerList 可用于侧边栏跳转
            currentRoute.node.name = route.name;
            // 将后台获取到的 title 同步到本地路由配置 用于页面标签显示
            route.meta.title = currentRoute.node.resource_name;
            router.addRoute('ManagePage', route);
          }
          return;
        }
        // 不是动态路由直接添加
        router.addRoute('ManagePage', route);
      });
    },
    clearState({ commit, state }) {
      commit('updateKeepAlive', {
        type: 'clear',
        routes: []
      });

      commit('updateTabsList', {
        type: 'clear',
        tab: []
      });

      commit('setMenuList', []);
      routeOptList.forEach((route) => {
        // 移除所有动态路由
        if (
          route.meta &&
          route.meta.isDynamic &&
          route.meta.id &&
          state.routeMap.get(route.meta.id)
        ) {
          router.removeRoute(route.name);
        }
      });
      commit('setRouteMap', new Map());
    }
  }
};
